import { render, staticRenderFns } from "./PortrayalResultForm.vue?vue&type=template&id=1f7723fa&"
import script from "./PortrayalResultForm.ts?vue&type=script&lang=ts&"
export * from "./PortrayalResultForm.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports